"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var IconButton = function (props) {
    return react_1.default.createElement(StyledButton, __assign({}, props), props.icon);
};
var StyledButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: inherit;\n  border: none;\n  background: none;\n  padding: 8px;\n  cursor: pointer;\n  &:disabled {\n    color: #e0e2e4;\n    cursor: default;\n  }\n"], ["\n  color: inherit;\n  border: none;\n  background: none;\n  padding: 8px;\n  cursor: pointer;\n  &:disabled {\n    color: #e0e2e4;\n    cursor: default;\n  }\n"])));
exports.default = IconButton;
var templateObject_1;
